import styled from "styled-components";

export const OpenApiWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
    height: 60px;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const FilterItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    padding-left: 10px;
    margin-bottom: 5px;
    box-sizing: border-box;
    letter-spacing: 2px;
`;

export const TableWrapper = styled.div`
    flex: 1 1 auto;
    border-radius: 5px;
    overflow-y: auto;
    margin: 0 20px;
`;

export const OpenApiTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
`;

export const OpenApiCard = styled.div`
    padding: 24px;
    margin: 0 20px 20px;
    color: #fff;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

export const OpenApiInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    margin-bottom: 16px;
`;

export const InfoLabel = styled.span`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 10px;
    letter-spacing: 1px;
`;

export const InfoValue = styled.span`
    font-size: 14px;
    color: #fff;
    word-break: break-all;
`;

export const InfoSwaggerLink = styled.span`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 4px;
    padding: 16px 12px;
    letter-spacing: 0.5px;
    text-align: right;

    a {
        color: #fff;
        text-decoration: underline;

        &:hover {
            opacity: 0.8;
        }
    }
`;

export const KeyDisplayWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #f5f5f5;
    padding: 6px 10px;
    border-radius: 4px;
    border: 1px solid #eee;
`;

export const KeyText = styled.span`
    font-size: 14px;
    color: #333;
    word-break: break-all;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    flex: 1;
`;

export const CopyButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1890ff;
    transition: color 0.2s;

    &:hover {
        color: #40a9ff;
    }

    &:disabled {
        color: #ccc;
        cursor: not-allowed;
    }
`;

export const CreateModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FormItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    margin-bottom: 5px;
`;